import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
} from '@angular/forms';
import {
  EmploymentFormEnum,
  EmploymentFormTypeEnum,
} from '@hrra/common-models';

@Component({
  selector: 'hrra-employment-form',
  templateUrl: './employment-form.component.html',
  styleUrls: ['./employment-form.component.scss'],
  standalone: false,
})
export class EmploymentFormComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Output() employment: EventEmitter<number[]> = new EventEmitter<number[]>();

  public employmentForm!: FormGroup;
  @Input() employmentFormTypes!: number[];

  onChange = (value) => {};
  onTouched = () => {};

  @Input() filter: any;
  constructor(private fb: FormBuilder) {}

  onWorkFromHomeChange() {
    if (this.employmentForm.controls.workFromHome.value) {
      this.employmentFormTypes = [
        ...this.employmentFormTypes,
        EmploymentFormTypeEnum.WorkFromHome,
      ];
    } else if (
      !this.employmentForm.controls.workFromHome.value &&
      this.employmentFormTypes.length > 0 &&
      this.employmentFormTypes.includes(EmploymentFormTypeEnum.WorkFromHome)
    ) {
      this.employmentFormTypes = this.employmentFormTypes.filter(
        (ef) => ef !== EmploymentFormTypeEnum.WorkFromHome
      );
    }
    this.employment.emit(this.employmentFormTypes);
  }

  onHybridChange() {
    if (this.employmentForm.controls.hybrid.value) {
      this.employmentFormTypes = [
        ...this.employmentFormTypes,
        EmploymentFormTypeEnum.Hybrid,
      ];
    } else if (
      !this.employmentForm.controls.hybrid.value &&
      this.employmentFormTypes.length > 0 &&
      this.employmentFormTypes.includes(EmploymentFormTypeEnum.Hybrid)
    ) {
      this.employmentFormTypes = this.employmentFormTypes.filter(
        (ef) => ef !== EmploymentFormTypeEnum.Hybrid
      );
    }
    this.employment.emit(this.employmentFormTypes);
  }

  onMobileFieldChange() {
    if (this.employmentForm.controls.mobileField.value) {
      this.employmentFormTypes = [
        ...this.employmentFormTypes,
        EmploymentFormTypeEnum.Field,
      ];
    } else if (
      !this.employmentForm.controls.mobileField.value &&
      this.employmentFormTypes.length > 0 &&
      this.employmentFormTypes.includes(EmploymentFormTypeEnum.Field)
    ) {
      this.employmentFormTypes = this.employmentFormTypes.filter(
        (ef) => ef !== EmploymentFormTypeEnum.Field
      );
    }
    this.employment.emit(this.employmentFormTypes);
  }

  onOnSiteChange() {
    if (this.employmentForm.controls.onSite.value) {
      this.employmentFormTypes = [
        ...this.employmentFormTypes,
        EmploymentFormTypeEnum.OnSite,
      ];
    } else if (!this.employmentForm.controls.onSite.value) {
      this.employmentFormTypes = this.employmentFormTypes.filter(
        (ef) => ef !== EmploymentFormTypeEnum.OnSite
      );
    }
    this.employment.emit(this.employmentFormTypes);
  }

  writeValue(value: any) {}

  isFormReseted(filter: any) {
    return !filter.length;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filter']) {
      if (
        this.employmentForm?.controls['workFromHome'].value == undefined &&
        this.filter.employmentFormTypeIds
      ) {
        this.employmentForm?.controls['workFromHome'].setValue(
          this.filter.employmentFormTypeIds.includes(
            EmploymentFormTypeEnum.WorkFromHome
          )
        );
      }
      if (
        this.employmentForm?.controls['hybrid'].value == undefined &&
        this.filter.employmentFormTypeIds
      ) {
        this.employmentForm?.controls['hybrid'].setValue(
          this.filter.employmentFormTypeIds.includes(
            EmploymentFormTypeEnum.Hybrid
          )
        );
      }
      if (
        this.employmentForm?.controls['onSite'].value == undefined &&
        this.filter.employmentFormTypeIds
      ) {
        this.employmentForm?.controls['onSite'].setValue(
          this.filter.employmentFormTypeIds.includes(
            EmploymentFormTypeEnum.OnSite
          )
        );
      }

      if (
        this.employmentForm?.controls['mobileField'].value == undefined &&
        this.filter.employmentFormTypeIds
      ) {
        this.employmentForm?.controls['mobileField'].setValue(
          this.filter.employmentFormTypeIds.includes(
            EmploymentFormTypeEnum.Field
          )
        );
      }

      const currentFilter = changes.filter.currentValue.employmentFormTypeIds;

      if (this.isFormReseted(currentFilter) && this.employmentForm != null) {
        this.employmentFormTypes = [];
        this.employmentForm.reset();
      }
    }
  }

  ngOnInit() {
    this.employmentForm = this.fb.group({
      workFromHome: new FormControl(undefined),
      hybrid: new FormControl(undefined),
      onSite: new FormControl(undefined),
      mobileField: new FormControl(undefined),
    });
  }
}
